import { useState } from "react";

export default function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch("/api/contact", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setSubmitted(true);
        setFormData({ name: "", email: "", message: "" });
        setTimeout(() => setSubmitted(false), 5000);
      } else {
        throw new Error("Failed to send message.");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: "100vh", background: "var(--c3-light, #f5f5f5)" }}>
      {/* Header */}
      <div
        style={{
          padding: "4rem 1rem",
          background: "color-mix(in srgb, var(--c1) 45%, white 55%)",
          textAlign: "center",
          color: "var(--ink)",
        }}
      >
        <h1 style={{ fontSize: "2.5rem", fontWeight: 900, margin: 0 }}>
          Get in Touch
        </h1>
        <p
          style={{
            fontSize: "1.1rem",
            color: "var(--ink-muted)",
            marginTop: "0.5rem",
          }}
        >
          Have questions? We'd love to hear from you!
        </p>
      </div>

      {/* Contact Form */}
      <div className="container" style={{ maxWidth: "600px", margin: "3rem auto" }}>
        <form onSubmit={handleSubmit} style={{ display: "grid", gap: "1.5rem" }}>
          {/* Name */}
          <div>
            <label
              htmlFor="name"
              style={{
                display: "block",
                fontWeight: 600,
                marginBottom: "0.5rem",
                color: "var(--ink)",
              }}
            >
              Your Name
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              placeholder="John Doe"
              style={{
                width: "100%",
                padding: "0.75rem 1rem",
                fontSize: "1rem",
                border: "1px solid var(--hairline)",
                borderRadius: "8px",
                fontFamily: "inherit",
                boxSizing: "border-box",
              }}
            />
          </div>

          {/* Email */}
          <div>
            <label
              htmlFor="email"
              style={{
                display: "block",
                fontWeight: 600,
                marginBottom: "0.5rem",
                color: "var(--ink)",
              }}
            >
              Your Email
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="you@example.com"
              style={{
                width: "100%",
                padding: "0.75rem 1rem",
                fontSize: "1rem",
                border: "1px solid var(--hairline)",
                borderRadius: "8px",
                fontFamily: "inherit",
                boxSizing: "border-box",
              }}
            />
          </div>

          {/* Message */}
          <div>
            <label
              htmlFor="message"
              style={{
                display: "block",
                fontWeight: 600,
                marginBottom: "0.5rem",
                color: "var(--ink)",
              }}
            >
              Message
            </label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
              placeholder="Tell us what's on your mind..."
              rows="5"
              style={{
                width: "100%",
                padding: "0.75rem 1rem",
                fontSize: "1rem",
                border: "1px solid var(--hairline)",
                borderRadius: "8px",
                fontFamily: "inherit",
                boxSizing: "border-box",
                resize: "vertical",
              }}
            />
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            disabled={loading}
            style={{
              padding: "0.75rem 2rem",
              fontSize: "1rem",
              fontWeight: 600,
              background: loading ? "var(--c3-muted)" : "var(--primary)",
              color: "black",
              border: "none",
              borderRadius: "8px",
              cursor: loading ? "not-allowed" : "pointer",
              transition: "all 0.3s ease",
              opacity: loading ? 0.7 : 1,
            }}
          >
            {loading ? "Sending..." : "Send Message"}
          </button>

          {/* Success Message */}
          {submitted && (
            <div
              style={{
                padding: "1rem",
                background: "#e8f5e9",
                border: "1px solid #4caf50",
                borderRadius: "8px",
                color: "#2e7d32",
                fontWeight: 600,
                textAlign: "center",
              }}
            >
              ✓ Thanks for reaching out! We'll get back to you soon.
            </div>
          )}
        </form>

        {/* Contact Info */}
        <div
          style={{
            marginTop: "4rem",
            padding: "2rem",
            background: "white",
            borderRadius: "12px",
            border: "1px solid var(--hairline)",
          }}
        >
          <h3 style={{ fontSize: "1.3rem", fontWeight: 700, marginBottom: "1rem" }}>
            Other Ways to Reach Us
          </h3>
          <p style={{ color: "var(--ink-muted)", margin: "0.5rem 0" }}>
            📧 Email:{" "}
            <a
              href="mailto:contact@befitfriends.com"
              style={{ color: "var(--primary)", textDecoration: "none" }}
            >
              contact@befitfriends.com
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}
